export const fileToBase64 = file => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = () => resolve(reader.result.replace(/^data:(.*,)?/, ""));
  reader.onerror = reject;
});
